// src/components/CustomFields/fields/RichTextEditor.tsx
// RichTextEditor component migrated from legacy

import React from 'react';
// jquery import removed (unused)
import ReactSummernoteCustom from '../../Globals/SummernoteCustom';

interface RichTextEditorProps {
  onChangeBody: (content: string) => void;
  body: string;
  placeholder?: string;
  height?: number;
  autoFocus?: boolean;
  onImageInsert?: (file: any) => void;
}

interface RichTextEditorState {
  body: string;
  dataListPeople: any[];
  dataPeopleName: any[];
  dataListGroup: any[];
}

class RichTextEditor extends React.Component<RichTextEditorProps, RichTextEditorState>
{
  constructor(props: RichTextEditorProps)
  {
    super(props);

    const dataPeopleName: any[] = [];
    const dataListPeople: any[] = [];
    const dataListGroup: any[] = [];

    this.state = {
      body: props.body || '',
      dataListPeople,
      dataPeopleName,
      dataListGroup,
    };

    this.onChangeSummernote = this.onChangeSummernote.bind(this);
    this.onImageInsert = this.onImageInsert.bind(this);
  }

  componentWillReceiveProps(nextProps: RichTextEditorProps)
  {
    if (nextProps.body !== this.state.body)
    {
      this.setState({ body: nextProps.body });
    }
  }

  onChangeSummernote(content: string)
  {
    this.setState({ body: content });
    if (this.props.onChangeBody)
    {
      this.props.onChangeBody(content);
    }
  }

  onImageInsert(file: any)
  {
    if (this.props.onImageInsert)
    {
      this.props.onImageInsert(file);
    }
  }

  render()
  {
    const { placeholder, height } = this.props;
    const { body } = this.state;

    return (
      <div className="corgee_com_rich-text-editor">
        <ReactSummernoteCustom
          value={body}
          options={{
            lang: 'en-US',
            height: height || 200,
            dialogsInBody: true,
            placeholder: placeholder || 'Enter text here...',
            toolbar: [
              ['style', ['style']],
              ['font', ['bold', 'underline', 'italic']],
              ['fontname', ['fontname']],
              ['color', ['color']],
              ['para', ['ul', 'ol']],
              ['table', ['table']],
              ['insert', ['link', 'picture']],
              ['view', ['codeview']],
            ],
            popover: {
              image: [['custom', ['imageAttributes', 'imageShape']]],
              link: [['link', ['linkDialogShow', 'unlink']]],
              air: [
                ['font', ['bold', 'underline', 'clear']],
                ['para', ['ul', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture']],
              ],
            },
          }}
          onChange={this.onChangeSummernote}
          onImageUpload={this.onImageInsert}
        />
      </div>
    );
  }
}

export default RichTextEditor;
